import React from "react";
import "./VideoShowcase.css";

export default function VideoShowcase() {
  return (
    <section className="video-showcase">
      <h2 className="video-title">See how it works!</h2>
      <div className="video-grid">
        <div className="video-wrapper">
          <iframe
             src="https://www.youtube.com/embed/BKJZvDli2TM"
            title="Demo Video 1"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="video-wrapper">
          <iframe
           src="https://www.youtube.com/embed/KacI9H0wzHM"
            title="Demo Video 2"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}
